var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section1"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoImg,"alt":""}})]),_c('nav-menu',{on:{"click":_vm.handleClick}}),_c('swiper')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }